import {Directive, forwardRef} from '@angular/core';
import {FormControl, NG_VALIDATORS, Validator} from '@angular/forms';

/*
Vor und hinter dem @ beliebig oft Buchstaben/Zahlen mit _-+. als Sonderzeichen erlaubt,
 */
export const EMAIL_VALIDATION_COMPLETE_REGEX = /^([\w]+)([-\._+\w]*)@([\w_\._+-]+)\.([a-zA-Z]+)$/;
// nach dem letzten "." beliebig viele Buchstaben (=Domain) erlaubt.
export const EMAIL_VALIDATION_DURING_INPUT_REGEX = /^([\w]+)([-\._+\w]*)@?([\w_\._+-]*)\.?([a-zA-Z]?)$/;

@Directive({
    providers: [
        {
            multi: true,
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => EmailValidatorDirective),
        },
    ],
    selector: '[lvEMailValidator]',
    standalone: false
})

export class EmailValidatorDirective implements Validator {
  private _VALIDATION_COMPLETE_REGEX = EMAIL_VALIDATION_COMPLETE_REGEX;
  private _VALIDATION_DURING_INPUT_REGEX = EMAIL_VALIDATION_DURING_INPUT_REGEX;

  public validate(control: FormControl): {} {
    if (!control || !control.value || control.value.length === 0) {
      return null;
    }
    if (control.value.endsWith(' ')) {
      control.patchValue(control.value.trim());
    }
    let validationResult: boolean;
    validationResult = this._validatePartialEmail(control.value);
    if (validationResult && !this._validateEmail(control.value)) {
      return {PARTIAL: 'WRONG_EMAIL', VIOLATION: 'Falsches Format'};
    }
    validationResult = this._validateEmail(control.value);
    if (!validationResult) {
      return {ERROR: 'WRONG_EMAIL'};
    }
    return null;
  }

  private _validatePartialEmail(value: string): boolean {
    return this._VALIDATION_DURING_INPUT_REGEX.test(value);
  }

  private _validateEmail(value: string): boolean {
    return this._VALIDATION_COMPLETE_REGEX.test(value);
  }
}
